import React from 'react';
import App from '../../../App/App';
// Override some styles
import './App.scss';

const AppFoursFringand = (props) => (
  <App {...props} containerExtraClassName="fours-fringand-fr" />
);
export default AppFoursFringand;
